import _ from "lodash";
import { APIHelper } from "../Apis/APIHelper";
import { error, success, warning } from "../Components/custom-toast/CustomToast";
import { t } from "i18next";
import { calculateAge, detectAndFormatBase64Image, isNullOrEmpty, navigateToNewTabExternal, openBase64Pdf } from "./service";


export const getProductPremiumDetails = async (fullname, birth, gender, phone, email, set) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000001",
    obj: {
      fullName: fullname,
      dob: birth,
      gender: gender,
      phoneNumber: phone,
      email: email,
      age: calculateAge(birth).toString(),
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      set(JSON.parse(data.jsonData));
    } else {
      error(data.message);
    }
  }
};

export const getProvince = async (set) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000002",
    obj: {},
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      set(jsonData);
    } else {
      error(data.message);
    }
  }
};

export const getDistrict = async (code, set, setLoading) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000003",
    obj: {
      provinceCode: code,
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    //
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      set(jsonData);
    } else {
      error(data.message);
    }
  }
  setTimeout(() => {
    setLoading(false);
  }, 200);
};

export const getWard = async (code, set, setLoading) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000004",
    obj: {
      // districtCode: code,
      provinceCode: code,
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      set(jsonData);
    } else {
      error(data.message);
    }
  }
  setTimeout(() => {
    setLoading(false);
  }, 200);
};

export const getOccupation = async (set) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000005",
    obj: {},
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      set(jsonData);
    } else {
      error(data.message);
    }
  }
};

export const saveDraft = async (baseDb, set) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000007",
    obj: {
      baseDb,
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      set(jsonData);
    } else {
      error(data.message);
    }
  }
};

export const nextStep = async (baseDb, set, setLoading) => {
  if(isNullOrEmpty(baseDb.sessionId)){
    if(!isNullOrEmpty(localStorage.getItem("%##%"))){
      baseDb = {...baseDb, sessionId: localStorage.getItem("%##%")};
    }
  }
  const body = {
    mesgId: "EPRODUCT_MESG_00000008",
    obj: baseDb,
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    setLoading(false);
    window.scrollTo(0,0);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      if(jsonData.data === undefined || isNullOrEmpty(jsonData.data)) {
        setLoading(false);
        window.scrollTo(0,0);
        return error(t("nulldata"));
      }
      if(jsonData.data.clientFlag === 1 && jsonData.data.step) {
        setLoading(false);
        set({...jsonData.data, idnumber: ""});
        window.scrollTo(0,0);
        return error(t("warningfailiduser"));
      }
      if (data.message === "1") {
        if (jsonData.code !== undefined && jsonData.code === "0") {
          setLoading(false);
          window.scrollTo(0,0);
          return error(jsonData.message);
        }
      }
      var dataJson = jsonData.data;
      if(dataJson.step === 1 && dataJson.productList?.length === 0) {
        setLoading(false);
        set({...baseDb, discount: 0, step: 0, productList: []});
        error(t("promotionCodeNotExisted"));
        return;
      }
      set(jsonData.data);
      if(!isNullOrEmpty(jsonData.data.sessionId)) {
        if(localStorage.getItem("%##%") !== jsonData.data.sessionId){
          localStorage.clear();
          localStorage.setItem("%##%", jsonData.data.sessionId);
          window.location.reload();
        }
        localStorage.setItem("%##%", jsonData.data.sessionId);
        
      } else {
        localStorage.clear();
        set({step: 0});
      }
    } else {
      error(data.message);
    }
  }
  setTimeout(() => {
    setLoading(false);
    window.scrollTo(0,0);
  }, 200);
};

export const previousStep = async (baseDb, set, setLoading) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000011",
    obj: baseDb,
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    setLoading(false);
    window.scrollTo(0,0);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      if (data.message === "1") {
        if (jsonData.code !== undefined && jsonData.code === "0") {
          setLoading(false);
          window.scrollTo(0,0);
          return error(jsonData.message);
        }
      }
      set(jsonData.data);
    } else {
      error(data.message);
    }
  }
  setTimeout(() => {
    setLoading(false);
    window.scrollTo(0,0);
  }, 200);
};

export const paymenttransfer = async (baseDb) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000009",
    obj: baseDb,
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    // setLoading(false);
    return error(t("lostconection"));
  });
  
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      // navigateToNewTabExternal("http://10.9.3.13:7001/payment/" + jsonData);
      navigateToNewTabExternal(jsonData);
    } else {
      return error(data.message);
    }
  }
};

export const paymentCallback = async (db, set, setLoading, setM) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000010",
    obj: {
      data: db,
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      
      if (jsonData.code === "1") {
        set((prev) => ({
          ...prev,
          ...jsonData.data,
          message: jsonData.message,
        }));
        setLoading(false);
        return true;
      }else if(jsonData.code === "2"){
        warning(jsonData.message);
        return null;
      }
      setLoading(false);
      set(jsonData.data);
      setM(jsonData.message);
      return false;
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 200);
      error(data.message);
      return null;
    }
  }
  setTimeout(() => {
    setLoading(false);
  }, 200);
};

export const getTypeTopic = async (set) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000013",
    obj: {},
  };
  const data = await APIHelper.postDataBasic(body).catch((error)=>{
    
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      set(jsonData);
    } else {
      error(data.message);
    }
  }
};

export const getTypeCus = async (set) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000014",
    obj: {},
  };
  const data = await APIHelper.postDataBasic(body).catch((error)=>{
    
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      set(jsonData);
    } else {
      error(data.message);
    }
  }
};

export const saveContact = async (object) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000015",
    obj: {
      fullName: object.fullName,
      phonePrefix: object.phonePrefix,
      phoneNumber: object.phoneNumber,
      email: object.email,
      typeCus: object.typeCus,
      poNumber: object.poNumber,
      typeTopic: object.typeTopic,
      note: object.note,
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((error)=>{
    
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      success(t("registersuccess"));
    } else {
      error(data.message);
    }
  }
};

export const testStep6 = async (baseDb, set) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000008",
    obj: baseDb,
  };
  const data = await APIHelper.postDataBasic(body).catch((error)=>{
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      
      set(jsonData.data);
    } else {
      error(data.message);
    }
  }
};

export const verifyBeforeAck = async (db, setLoading) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000017",
    obj: {
      data: db.data,
      code: db.code
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((error)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      setTimeout(() => {
        setLoading(false);
      }, 200);
      success(data.message);
      return true;
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 200);
      error(data.message);
      return false;
    }
  }
  setTimeout(() => {
    setLoading(false);
  }, 200);
  return false;
};

export const paymentSuccess = async (db, setLoading) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000016",
    obj: {
      data: db
    }
    ,
  };
  const data = await APIHelper.postDataBasic(body).catch((error)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      if (jsonData.code === "1") {
        success(jsonData.message);
      } else {
        alert(jsonData.message);
      }
      return setTimeout(() => {
        setLoading(false);
      }, 200);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 200);
      return warning(data.message);
    }
  }
  setTimeout(() => {
    setLoading(false);
  }, 200);
};



export const sendOtpEkyc = async (objectDto, set, setLoading) => {
  if(isNullOrEmpty(objectDto.phoneNumber)) return warning(t("nullphone"));
  const body = {
    mesgId: "EPRODUCT_MESG_00000020",
    obj: objectDto,
  };
  const data = await APIHelper.postDataBasic(body).catch((error)=>{
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      var verifyStatusOtpEkycDto = await verifyStatusOtpEkyc(jsonData);
      if(verifyStatusOtpEkycDto !== null && verifyStatusOtpEkycDto !== false){
        set(verifyStatusOtpEkycDto);
        setLoading(false);
        return true;
      }else{
        setLoading(false);
        return false;
      }
    } else {
      error(data.message);
      setLoading(false);
      return false;
    }
  }
  setLoading(false);
  return null;
};

export const verifyStatusOtpEkyc = async (objectDto) => {
  var count = 1;
  if(isNullOrEmpty(objectDto.phoneNumber)) return warning(t("nullphone"));
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  while(count <= process.env.REACT_APP_RECALL_OTP){
    await delay(process.env.REACT_APP_DELAY_OTP);
    const body = {
      mesgId: "EPRODUCT_MESG_00000037",
      obj: objectDto,
    };
    const data = await APIHelper.postDataBasic(body).catch((error)=>{
    });
    if (!isNullOrEmpty(data) && data !== "ERR") {
      if (data.code === "1") {
        var jsonData = JSON.parse(data.jsonData);
        return { ...objectDto, vendorType: jsonData.vendorType };
      } else {
        if(count === process.env.REACT_APP_RECALL_OTP){
          error(data.message);
          return false;
        }else{
          count++;
          continue;
        }
      }
    }
    return null;
  }
};

export const verifyOtpEkyc = async (objectDto) => {
  if(isNullOrEmpty(objectDto.phoneNumber)) return warning(t("nullphone"));
  if(isNullOrEmpty(objectDto.phoneOtp)) return warning(t("nullphoneotp"));
  const body = {
    mesgId: "EPRODUCT_MESG_00000021",
    obj: {
      "phoneNumber": objectDto.phoneNumber,
      "phoneOtp": objectDto.phoneOtp
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    
    if (data.code === "1") {
      return true;
    } else {
      warning(data.message);
      return false;
    }
  }
  return null;
};



export const ekycTransfer = async (baseDb) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000019",
    obj: {...baseDb, ekyc_position: "01"},
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      if(jsonData.status !== 1) {
        return error(jsonData.statusDescr);
      }
      if(!isNullOrEmpty(jsonData.statusDescr)) 
      {
        success(jsonData.statusDescr);
      }
	  if(jsonData.code === "208"){
        window.location.reload();
        return;
      }
      if(!isNullOrEmpty(jsonData.link)){
        return navigateToNewTabExternal(jsonData.link);
      }else alert(t("errortrylater"));
      
      return false;
    } else {
      error(data.message);
      return false;
    }
  }
};

export const ekycCallback = async (db, set, setLoading, setM) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000024",
    obj: {
      data: db,
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((error)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      
      if (jsonData.code === "1") {
        var dataJsonData = JSON.parse(jsonData.data);
        if(dataJsonData.ekyc === 1){
          set(dataJsonData);
          success(jsonData.message);
          setLoading(false);
          return true;
        }else if(dataJsonData.ekyc === 2 || dataJsonData.ekyc === 0){
          setLoading(false);
          warning(jsonData.message);
          if(dataJsonData.ekyc === 2){
            return false;
          }
          return null;
        }
        return warning(jsonData.message);
      }else if(jsonData.code === "0"){
        error(t("ekyclostconnect"));
        set({step: 0});
        return null;
      }
      setM(jsonData.message);
      set(null)
      setLoading(false);
      return false;
    } else {
      error(data.message);
      localStorage.clear();
      set({step: 0});
      return null;
    }
  }
  setTimeout(() => {
    setLoading(false);
  }, 200);
};


export const downloadFilePdf = async (objectDto, position) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000031",
    obj: {
      id: objectDto.id,
      position: position
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      openBase64Pdf(jsonData.base64, jsonData.fileName)
    } else {
      error(data.message);
    }
  }
};


export const ackCallback = async (db, setLoading) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000032",
    obj: {
      "data": db,
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((error)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      if (jsonData === "1") {
          setLoading(false);
          return true;
        }else{
          setLoading(false);
          return false;
        }
    }
  }
  setTimeout(() => {
    setLoading(false);
    return null;
  }, 200);
};

export const uploadImageTemp = async (file, sessionId, fileName) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("mesgId", "EPRODUCT_MESG_00000034");
  formData.append("mesgData", sessionId+":"+fileName);
  const param = {
    "mesgId": "EPRODUCT_MESG_00000034",
    "mesgData": sessionId+":"+fileName,
}
  try {
      const res = await APIHelper.postMultiFileBasic(formData, param);
      if (res.code === "1") {
          return true;
      } else {
          return false;
      }
  } catch (err) {
      console.error("Upload error", err);
  }
  return false;
}

// export const uploadImageTemp = async (file, sessionId, fileName) => {
//   const formData = new FormData();
//   formData.append("file", file);
//   const param = {
//     "mesgId": "EPRODUCT_MESG_00000034",
//     "mesgData": sessionId+":"+fileName,
// }
//   try {
//       const res = await APIHelper.postMultiFileBasic(formData, param);
//       if (res.code === "1") {
//           return true;
//       } else {
//           return false;
//       }
//   } catch (err) {
//       console.error("Upload error", err);
//   }
//   return false;
// }

export const getFileTemp = async (sessionId, setLoading, setFront, setBack) => {
  const body = {
    mesgId: "EPRODUCT_MESG_00000035",
    obj: {
      "sessionId": sessionId,
    },
  };
  const data = await APIHelper.postDataBasic(body).catch((error)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      setTimeout(() => {
        setLoading(false);
      }, 200);
      if(isNullOrEmpty(jsonData)) return;
      if(jsonData.length > 0) {
        for (let i = 0; i < jsonData.length; i++) {
          if (jsonData[i].position === 1) {
            if(!isNullOrEmpty(jsonData[i].base64)) 
              setFront({base64: detectAndFormatBase64Image(jsonData[i].base64)});
          }else if(jsonData[i].position === 2){
            if(!isNullOrEmpty(jsonData[i].base64)) 
              setBack({base64: detectAndFormatBase64Image(jsonData[i].base64)});
          }
        }
      }
      return;
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 200);
      error(data.message);
    }
  }
  setTimeout(() => {
    setLoading(false);
  }, 200);
};

export const splitAddress = (objectDto, setObjectDto) => {
  const split30 = (value = "") => {
  const text = value
    .normalize("NFC")
    .trim()
    .slice(0, 60);

  if (text.length <= 30) {
    return { line1: text, line2: "" };
  }

  let splitIndex = text.lastIndexOf(" ", 30);

  if (splitIndex === -1) {
    splitIndex = 30;
  }

  return {
    line1: text.slice(0, splitIndex).trim(),
    line2: text.slice(splitIndex).trim()
  };
};

  const address = split30(objectDto.address);
  const contact = split30(objectDto.contactAddress);

  const isDifferent =
    (objectDto.address1 || "") + (objectDto.address2 || "") !== (objectDto.address || "").slice(0, 60).trim() ||
    (objectDto.contactAddress1 || "") + (objectDto.contactAddress2 || "") !== (objectDto.contactAddress || "").slice(0, 60).trim();

  if (isDifferent) {
    setObjectDto(prev => ({
      ...prev,
      address1: address.line1,
      address2: address.line2,
      contactAddress1: contact.line1,
      contactAddress2: contact.line2
    }));
  }
};


export const validateValidPromotionCode = async (baseDb, set, setLoading) => {
  if(isNullOrEmpty(baseDb.sessionId)){
    if(!isNullOrEmpty(localStorage.getItem("%##%"))){
      baseDb = {...baseDb, sessionId: localStorage.getItem("%##%")};
    }
  }
  const body = {
    mesgId: "EPRODUCT_MESG_00000038",
    obj: baseDb,
  };
  const data = await APIHelper.postDataBasic(body).catch((err)=>{
    setLoading(false);
    return error(t("lostconection"));
  });
  if (!isNullOrEmpty(data) && data !== "ERR") {
    if (data.code === "1") {
      var jsonData = JSON.parse(data.jsonData);
      if(jsonData === undefined || isNullOrEmpty(jsonData)) {
        setLoading(false);
        set({...baseDb, discount: 0, step: 0, productList: []});
        error(t("promotionCodeNotExisted"));
        return;
      }else{
        if(jsonData.remainingUsage > 0){
          nextStep({...baseDb, discount: jsonData.discount}, set, setLoading);
        }else{
          set({...baseDb, discount: 0, step: 0, productList: []});
          setLoading(false);
          error(t("promotionCodeMatchLimit"));
          return;
        }
      }
    } else {
      set({...baseDb, discount: 0, step: 0, productList: []});
      setLoading(false);
      error(data.message);
      return;
    }
  }
};
export const validateAgentCode = async (baseDb, setLoading) => {
  try {
    const body = {
      mesgId: "EPRODUCT_MESG_00000039",
      obj: baseDb,
    };

    const data = await APIHelper.postDataBasic(body);

    if (!isNullOrEmpty(data) && data !== "ERR") {
      if (data.code === "1") {
        const jsonData = JSON.parse(data.jsonData);

        if (!jsonData || isNullOrEmpty(jsonData)) {
          error(t("agentcodenotexisted"));
          setLoading(false);
          return false;
        }

        return true;
      }

      error(data.message);
      setLoading(false);
      return false;
    }
    setLoading(false);
    return false;
  } catch (err) {
    error(t("lostconection"));
    setLoading(false);
    return false;
  }
};